// 推广参数配置
const promotionParam = {
	// 团队推广参数
	team: {
		sourceFunds: 1,
		promotionRate: 0
	},
	// 个人推广参数
	personal: {
		promotionRate: 0
	},
	// 解析团队推广参数
	parseTeamPromotionParam(param) {
		// 获取团队推广参数作为基础对象
		let baseParam = {
			...this.team
		}
		// 尝试解析传入的参数
		try {
			if (param) {
				let parsedParam = JSON.parse(param)
				// 使用解析后的参数覆盖基础对象中的对应字段
				// 这样当添加新参数时，会自动包含在返回对象中
				Object.keys(baseParam).forEach(key => {
					if (parsedParam[key] !== undefined) {
						baseParam[key] = parsedParam[key]
					}
				})
			}
		} catch (error) {
			console.error('推广参数格式错误', error)
			// 错误时返回团队推广参数
			return {
				...this.team
			}
		}
		return baseParam
	},
	// 解析个人推广参数
	parsePersonalPromotionParam(param) {
		// 获取个人推广参数作为基础对象
		let baseParam = {
			...this.personal
		}
		// 尝试解析传入的参数
		try {
			if (param) {
				let parsedParam = JSON.parse(param)
				// 使用解析后的参数覆盖基础对象中的对应字段
				// 这样当添加新参数时，会自动包含在返回对象中
				Object.keys(baseParam).forEach(key => {
					if (parsedParam[key] !== undefined) {
						baseParam[key] = parsedParam[key]
					}
				})
			}
		} catch (error) {
			console.error('推广参数格式错误', error)
			// 错误时返回个人推广参数
			return {
				...this.personal
			}
		}
		return baseParam
	}
}

export default promotionParam